/**
 * Pure geometry for the Ontology sector mark (rim points + scooped wedge paths).
 * deg 0 = east, 90 = south (SVG y-down).
 */

/** @param {number} deg */
export function ontologyRimPoint(cx, cy, r, deg) {
  const t = (deg * Math.PI) / 180;
  return { x: cx + r * Math.cos(t), y: cy + r * Math.sin(t) };
}

function fmt(n) {
  return n.toFixed(2);
}

/**
 * Wedge: hub → rim; outer edge is quadratic with control pulled toward center (concave rim).
 */
export function ontologySectorPath(cx, cy, outerR, centerDeg, halfAngle, indentTowardCenter = 0.2) {
  const start = ontologyRimPoint(cx, cy, outerR, centerDeg - halfAngle);
  const end = ontologyRimPoint(cx, cy, outerR, centerDeg + halfAngle);
  const mx = (start.x + end.x) / 2;
  const my = (start.y + end.y) / 2;
  const qx = mx + indentTowardCenter * (cx - mx);
  const qy = my + indentTowardCenter * (cy - my);
  return `M ${cx} ${cy} L ${fmt(start.x)} ${fmt(start.y)} Q ${fmt(qx)} ${fmt(qy)} ${fmt(end.x)} ${fmt(end.y)} Z`;
}

/**
 * Annular wedge: inner circle arc → outer scooped rim → inner arc back.
 * Four sectors with the same innerR leave a round negative space at the hub (no fill).
 */
export function ontologySectorPathAnnular(
  cx,
  cy,
  innerR,
  outerR,
  centerDeg,
  halfAngle,
  indentTowardCenter = 0.2,
) {
  const innerStart = ontologyRimPoint(cx, cy, innerR, centerDeg - halfAngle);
  const innerEnd = ontologyRimPoint(cx, cy, innerR, centerDeg + halfAngle);
  const outerStart = ontologyRimPoint(cx, cy, outerR, centerDeg - halfAngle);
  const outerEnd = ontologyRimPoint(cx, cy, outerR, centerDeg + halfAngle);
  const mx = (outerStart.x + outerEnd.x) / 2;
  const my = (outerStart.y + outerEnd.y) / 2;
  const qx = mx + indentTowardCenter * (cx - mx);
  const qy = my + indentTowardCenter * (cy - my);
  const span = 2 * halfAngle;
  const largeArc = span > 180 ? 1 : 0;
  const sweep = 0;
  return `M ${fmt(innerStart.x)} ${fmt(innerStart.y)} L ${fmt(outerStart.x)} ${fmt(outerStart.y)} Q ${fmt(qx)} ${fmt(qy)} ${fmt(outerEnd.x)} ${fmt(outerEnd.y)} L ${fmt(innerEnd.x)} ${fmt(innerEnd.y)} A ${fmt(innerR)} ${fmt(innerR)} 0 ${largeArc} ${sweep} ${fmt(innerStart.x)} ${fmt(innerStart.y)} Z`;
}
